import APIClient from './index';
import _ from 'lodash';

export const getBrandTrackingHealth = params => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AdminBrandTrackingHealth?${new URLSearchParams(params).toString()}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getBrandTrackingHealthDetail = brandId => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AdminBrandTrackingHealth/${brandId}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const sendBrandTrackingHealthTestEmail = brandId => {
  return new Promise((resolve, reject) => {
    APIClient.post(`AdminBrandTrackingHealth/${brandId}/test-email`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getBrandTrackingHealthListStats = brandIds => {
  return new Promise((resolve, reject) => {
    APIClient.post('AdminBrandTrackingHealth/list-stats', { brandIds })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
